import { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";

import { SpinnerBlock } from "@common/SpinnerBlock";

import { Payment } from "@components/Donat/Payment";
import { Rate } from "@components/Donat/Rate";
import { ConnectWithUs } from "@components/ConnectWithUs/ConnectWithUs";

import { openModal } from "@store/slices/sliceModal";

import { fetchSettings } from "@store/slices/sliceSettings";
import { fetchPayment } from "@store/slices/sliceDonat";

const Donat = () => {
  const [isDonatLoading, setDonatLoading] = useState(true);
  const [isSettingLoading, setSettingLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSettings());
    dispatch(fetchPayment());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const hashUrl = window.location.hash;

    let timer;

    if (isDonatLoading && isSettingLoading) {
      timer = setTimeout(() => {
        if (hashUrl === '#success') {
          dispatch(openModal({ modalComplete: true }))
  
        } else if (hashUrl === '#error') {
          dispatch(openModal({ modalFatal: true }))
  
        } else {
          dispatch(openModal({ modalBotProtect: true }))
        }
  
      }, 2000);
    }

    return () => {
      clearTimeout(timer);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDonatLoading, isSettingLoading]);

  const {payment: {status: donat}} = useSelector((state) => state.donat);
  const {settings : {status : setting}} = useSelector((state) => state.settings);

  useMemo(() => {
    setDonatLoading(donat === "loaded");
  }, [donat]);

  useMemo(() => {
    setSettingLoading(setting === "loaded");

  }, [setting]);

  if (!isDonatLoading || !isSettingLoading) {
   return <SpinnerBlock />;
  }

  if (isDonatLoading && isSettingLoading) {
    return (
      <>
        <Payment />
        <Rate />
        <ConnectWithUs />
      </>
    );
  }
};

export default Donat;
